export default __webpack_public_path__ + "static/background-computer-96ef4af1e8be99e2a8e72cfaaf0a89a5.jpeg";